module.exports = __webpack_public_path__ + "img-haus-Foundation@2x.png";


//////////////////
// WEBPACK FOOTER
// ./app/features/dashboard/images/img-haus-Foundation@2x.png
// module id = 488
// module chunks = 0